module.exports = __webpack_public_path__ + "static/media/im-rahmen2.e0581fb4.png";